import * as Response from './response'
import { ChatConfigData } from './types'

export function convertChatConfig(
  response: Response.ChatConfig
): ChatConfigData {
  return {
    maxVideoDuration: response.max_video_duration ?? 60,
    autoRefreshSeconds: response.auto_refresh_seconds ?? 10,
    maxMessageAge: response.max_message_age ?? 21,
    allowMarkMessages: response.allow_mark_messages,
    allowPinMessages: response.allow_pin_messages,
    allowReactions: response.allow_reactions,
    allowSearchMessages: response.allow_search_messages,
    showSentMessages: response.show_sent_messages,
    useComposeMessage: response.use_compose_message,
    allowMentions: response.allow_mentions,
  }
}
